import React, {useEffect, useMemo, useState} from 'react'
import {mapRecompraProgramadaToTable, recompraProgramadaFields} from "./recompra-programada-fields"
import {Paper} from "@mui/material"
import DynamicColumnTable from "../../../componentes/dynamic-column-table"
import PropTypes from "prop-types"
import {copyTable, pasteTableFromClipboard} from "../../../../utils/csv-utils"
import {useLocation} from "react-router-dom"
import MotorRecompraProgramadaService from "../../../../../../../services/motor-recompra-programada-service"
import {useDraftLoadGuard} from "../../../use-draft-load-guard"
import {dispatchSnackbar} from "../../../../../../components/SnackBar/snackbar-bus"

const RecompraTable = ({
                           setLoading,
                           idCaracteristica,
                           recompraPublicado,
                           tableData,
                           setTableData,
                           clearTable,
                           onDraftEdit,
                       }) => {

    const service = useMemo(() => new MotorRecompraProgramadaService(), [])
    const [tableKey, setTableKey] = useState(Math.random() * 10)
    const location = useLocation()
    const navigationState = location.state
    const {beginDraftLoad, onLocalEdit} = useDraftLoadGuard(idCaracteristica, tableData, onDraftEdit)

    useEffect(() => {
        if (!idCaracteristica) return

        const origem = navigationState?.origem
        if (origem === "ver") {
            loadRecompraProgramada(beginDraftLoad())
        }
    }, [beginDraftLoad, idCaracteristica, navigationState])

    useEffect(() => {
        if (navigationState?.origem !== "duplicar") return
        const dadosOrigem =
            navigationState?.Data?.RecompraProgramada?.RecomprasProgramadas ?? []
        
        const formatted = mapRecompraProgramadaToTable(dadosOrigem)
        recompraPublicado(false)
        setTableData(formatted)
        setTableKey(Math.random() * 10)
        console.log(
            "NAVIGATION DATA:",
            navigationState?.Data
        )

        console.log(
            "RECOMPRAS:",
            navigationState?.Data?.RecomprasProgramadas
        )   
    }, [navigationState, recompraPublicado, setTableData])

    const loadRecompraProgramada = async (guard) => {
        let failed = false
        setLoading(true)
        try {
            const response = await service.getRecompraProgramada(idCaracteristica)
            if (!guard.canApply()) return

            const {body} = response
            const {RecomprasProgramadas} = body
            if (!Array.isArray(RecomprasProgramadas)) throw new Error("Resposta de recompra programada inválida")

            if (RecomprasProgramadas.length > 0) {
                recompraPublicado(true)
                const formatted = mapRecompraProgramadaToTable(RecomprasProgramadas)
                setTableData(formatted)
                setTableKey(Math.random() * 10)
            } else {
                await loadRecompraProgramadaTemporario(guard)
            }
        } catch {
            if (guard.canApply()) {
                failed = true
                dispatchSnackbar("Não foi possível carregar as recompras programadas.", "error")
            }
        } finally {
            if (guard.isCurrent()) setLoading(failed ? "error" : false)
        }
    }

    const loadRecompraProgramadaTemporario = async (guard) => {
        try {
            const response = await service.getTemporarioRecompraProgramada(idCaracteristica)
            if (!guard.canApply()) return

            const bodyTemp = response?.body || response?.data

            if (bodyTemp) {
                const recompras = Array.isArray(bodyTemp)
                    ? bodyTemp
                    : bodyTemp?.RecomprasProgramadas
                if (!Array.isArray(recompras)) throw new Error("Resposta de recompra programada inválida")

                const formatted = mapRecompraProgramadaToTable(recompras)

                setTableData(formatted)
                setTableKey(Math.random() * 10)
            } else throw new Error("Resposta de recompra programada inválida")
        } catch (error) {
            if (error?.status !== 400) throw error
        }
    }

    return (
        <Paper sx={{mt: 2}}>
            <DynamicColumnTable
                key={tableKey}
                actionButtons={true}
                copyData={() => copyTable(tableData, recompraProgramadaFields)}
                pasteData={async () => await pasteTableFromClipboard(
                    recompraProgramadaFields,
                    (rows) => {
                        onLocalEdit()
                        setTableData(rows)
                    },
                )}
                clearTable={() => {
                    onLocalEdit()
                    clearTable(setTableData)
                }}
                onUserEdit={onLocalEdit}
                fields={recompraProgramadaFields}
                items={tableData}
                setItems={setTableData}
            />
        </Paper>
    )
}

RecompraTable.propTypes = {
    setLoading: PropTypes.func,
    idCaracteristica: PropTypes.number,
    recompraPublicado: PropTypes.func,
    tableData: PropTypes.array,
    setTableData: PropTypes.func,
    clearTable: PropTypes.func,
    onDraftEdit: PropTypes.func,
}

export default RecompraTable
